/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {SSOUserModel} from '../../../../app/modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import UserRole from '../../../../app/models/UserRole'
import axios from 'axios'
import {APIResponse} from '../../../../app/models/HelperModel'
import {PegawaiUserManagement} from '../../../../app/pages/user-management/UserManagement'
import {IMenu} from '../../../../app/modules/auth/models/MenuModel'

export function AsideMenuMain() {
  const intl = useIntl()
  const API_URL = process.env.REACT_APP_API_URL
  const GET_PEGAWAI_ROLE_PENGELOLA = `${API_URL}/rolepengelola/datapengelolarole`

  const [isPJSatker, setIsPJSatker] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [satuanKerjaId, satuanKerjaName] = useSelector<RootState>(({auth}) => {
    return [
      auth.user?.pegawaiData.administrative_unit_id,
      auth.user?.pegawaiData.administrative_name,
    ]
  }) as string[]

  const user: SSOUserModel = useSelector<RootState>(({auth}) => auth.user) as SSOUserModel

  const role = user.userrole?.data?.role

  const objPengelolaSatker = user.pengelolaSatker

  const userMenu: IMenu[] = useSelector<RootState>(({auth}) => auth.menu, shallowEqual) as IMenu[]

  const getData = () => {
    setIsLoading(true)

    axios
      .get<APIResponse<PegawaiUserManagement[]>>(GET_PEGAWAI_ROLE_PENGELOLA, {
        params: {
          role: 1,
        },
      })
      .then((response) => {
        const {data} = response.data

        if (data) {
          if (data.find((obj) => obj.username_intra == user.userData.username)) {
            setIsPJSatker(true)
          }

          setIsLoading(false)
        }

        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    // <>
    //   <AsideMenuItem
    //     to='/dashboard'
    //     icon='/media/icons/duotune/art/art002.svg'
    //     title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
    //     fontIcon='bi-app-indicator'
    //   />
    //   <AsideMenuItem
    //     to='/builder'
    //     icon='/media/icons/duotune/general/gen019.svg'
    //     title='Layout Builder'
    //     fontIcon='bi-layers'
    //   />
    //   <div className='menu-item'>
    //     <div className='menu-content pt-8 pb-2'>
    //       <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
    //     </div>
    //   </div>
    //   <AsideMenuItemWithSub
    //     to='/crafted/pages'
    //     title='Pages'
    //     fontIcon='bi-archive'
    //     icon='/media/icons/duotune/general/gen022.svg'
    //   >
    //     <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
    //       <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
    //       <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
    //       <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
    //       <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
    //       <AsideMenuItem
    //         to='/crafted/pages/profile/connections'
    //         title='Connections'
    //         hasBullet={true}
    //       />
    //     </AsideMenuItemWithSub>

    //     <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
    //       <AsideMenuItem
    //         to='/crafted/pages/wizards/horizontal'
    //         title='Horizontal'
    //         hasBullet={true}
    //       />
    //       <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
    //     </AsideMenuItemWithSub>
    //   </AsideMenuItemWithSub>
    //   <AsideMenuItemWithSub
    //     to='/crafted/accounts'
    //     title='Accounts'
    //     icon='/media/icons/duotune/communication/com006.svg'
    //     fontIcon='bi-person'
    //   >
    //     <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
    //     <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
    //   </AsideMenuItemWithSub>
    //   <AsideMenuItemWithSub
    //     to='/error'
    //     title='Errors'
    //     fontIcon='bi-sticky'
    //     icon='/media/icons/duotune/general/gen040.svg'
    //   >
    //     <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
    //     <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
    //   </AsideMenuItemWithSub>
    //   <AsideMenuItemWithSub
    //     to='/crafted/widgets'
    //     title='Widgets'
    //     icon='/media/icons/duotune/general/gen025.svg'
    //     fontIcon='bi-layers'
    //   >
    //     <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
    //     <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
    //     <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
    //     <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
    //     <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
    //     <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
    //   </AsideMenuItemWithSub>
    //   <div className='menu-item'>
    //     <div className='menu-content pt-8 pb-2'>
    //       <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
    //     </div>
    //   </div>
    //   <AsideMenuItemWithSub
    //     to='/apps/chat'
    //     title='Chat'
    //     fontIcon='bi-chat-left'
    //     icon='/media/icons/duotune/communication/com012.svg'
    //   >
    //     <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
    //     <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
    //     <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
    //   </AsideMenuItemWithSub>
    //   <div className='menu-item'>
    //     <div className='menu-content'>
    //       <div className='separator mx-1 my-4'></div>
    //     </div>
    //   </div>
    //   <div className='menu-item'>
    //     <a
    //       target='_blank'
    //       className='menu-link'
    //       href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
    //     >
    //       <span className='menu-icon'>
    //         <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
    //       </span>
    //       <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
    //     </a>
    //   </div>
    // </>
    <>
      {/* BEGIN - DISABLE FOR PRODUCTION  */}
      {/* <AsideMenuItem
        to='/dashboard'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='fa-chart-bar'
      />
      <AsideMenuItem to='/beranda' title='Beranda' fontIcon='fa-home' />
      <AsideMenuItem to='/chart-beranda' title='Beranda Chart' fontIcon='fa-home' />
      <AsideMenuItem
        to='/dashboard-percepatan'
        title='Dashboard Percepatan'
        fontIcon='fa-chart-pie'
      />
      <AsideMenuItem to='/percepatan-rin' title='Percepatan RIN' fontIcon='fa-forward' />
      <AsideMenuItemWithSub to='#' title='Kinerja-Ku' fontIcon='fas fa-bookmark'>
        <AsideMenuItem to='/arah-risnov' title='Arah Risnov' hasBullet={true} />
        <AsideMenuItem to='/jejak-risnov' title='Jejak Risnov' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='#' title='Penetapan' fontIcon='fa-stamp'>
        <AsideMenuItem to='/daftar-penetapan-komponen' title='Komponen' hasBullet={true} />
        <AsideMenuItem to='/daftar-penetapan-ro' title='Rincian Output' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='#'
        title='Pelaporan'
        fontIcon='fa-pen-fancy'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <AsideMenuItem to='/daftar-pelaporan-komponen' title='Komponen' hasBullet={true} />
        <AsideMenuItem to='/daftar-pelaporan-ro' title='Rincian Output' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem
        to='#'
        title='Export Laporan'
        fontIcon='fa-file-excel'
        icon='/media/icons/duotune/communication/com012.svg'
      />
      <AsideMenuItem
        to='dashboard-publikasiku'
        title='Dashboard Publikasi-Ku'
        fontIcon='fal fa-signal'
      /> */}
      {/* END - DISABLE FOR PRODUCTION  */}

      <AsideMenuItem to='/publikasiku' title='Publikasi-Ku' fontIcon='fa-home' />

      {/* BEGIN - DISABLE FOR PRODUCTION  */}
      {/* {(satuanKerjaId == '76' && objPengelolaSatker.role.length > 0) ||
      (role === undefined
        ? null
        : !!role.find((el) => el.id.toString() == UserRole.SuperAdminErenmonev.toString())) ? (
        <AsideMenuItemWithSub
          to=''
          title='Kinerja'
          fontIcon='fas fa-scroll'
          icon='/media/icons/duotune/general/gen022.svg'
        >
          <AsideMenuItemWithSub
            to='/perkin-kepala'
            title='Perjanjian Kinerja'
            fontIcon='fas fa-handshake'
            icon='/media/icons/duotune/general/gen022.svg'
          >
            <AsideMenuItem to='/perkin-kepala' title='Kepala BRIN' hasBullet={true} />
            <AsideMenuItem to='/perkin-satker' title='Satuan Kerja BRIN' hasBullet={true} />
          </AsideMenuItemWithSub>
          <AsideMenuItemWithSub
            to=''
            title='Realisasi Kinerja'
            fontIcon='fas fa-file-contract'
            icon='/media/icons/duotune/general/gen022.svg'
          >
            <AsideMenuItem to='/realisasi-kinerja-kepala' title='Kepala BRIN' hasBullet={true} />
            <AsideMenuItem
              to='/realisasi-kinerja-satker'
              title='Satuan Kerja BRIN'
              hasBullet={true}
            />
          </AsideMenuItemWithSub>
        </AsideMenuItemWithSub>
      ) : null}

      <AsideMenuItem to='/struktur-kinerja' title='Struktur Kinerja' fontIcon='fa-folder-tree' />
      <AsideMenuItem to='/percepatan-program-rin' title='Percepatan Program RIN' fontIcon='fa-microscope' /> */}
      {/* END - DISABLE FOR PRODUCTION  */}

      {role === undefined ? null : role.length > 0 || objPengelolaSatker.role.length > 0 ? ( // do not render if undefined // check if role array has element
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-danger fs-8 ls-1'>Menu Khusus</span>
          </div>
        </div>
      ) : null}
      {role === undefined ? null : role.find(
          (el) =>
            el.id.toString() ===
            (UserRole.VerifikatorErenMonev.toString() || UserRole.SuperAdminErenmonev.toString())
        ) ? (
        <AsideMenuItemWithSub
          to='#'
          title='Koor Program Satker'
          fontIcon='fa-pen-fancy'
          icon='/media/icons/duotune/general/gen022.svg'
        >
          <AsideMenuItem to='/publikasi-satker' title='Publikasi Satker' hasBullet={true} />
        </AsideMenuItemWithSub>
      ) : null}
      {role === undefined ? null : role.find(
          (el) =>
            el.id.toString() ===
            (UserRole.PengelolaPusatErenmonev.toString() || UserRole.SuperAdminErenmonev.toString())
        ) ? (
        <AsideMenuItem
          to={'/peran-pengguna'}
          title='Manajemen Pengguna'
          fontIcon='fas fa-user-lock'
        />
      ) : null}
      {(role === undefined
        ? false
        : role.find((el) => el.id.toString() === UserRole.SuperAdminErenmonev.toString())) ||
      objPengelolaSatker.role.length > 0 ? (
        <AsideMenuItem
          to={'/pengelola-satker'}
          title='Pengelola Satuan Kerja'
          fontIcon='fas fa-hospital-user'
        />
      ) : null}

      {/* BEGIN - DISABLE FOR PRODUCTION  */}
      {/* {(
        role === undefined
          ? false
          : role.find((el) => el.id.toString() === UserRole.SuperAdminErenmonev.toString())
      ) ? (
        <AsideMenuItem
          to={'/master-satuan-pk'}
          title='Master Satuan Perjanjian Kinerja'
          fontIcon='fas fa-wand-magic-sparkles'
        />
      ) : null} */}
      {/* END - DISABLE FOR PRODUCTION  */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-danger fs-8 ls-1'>Lainnya</span>
        </div>
      </div>
      <AsideMenuItem to='/bantuan' title='Bantuan Aplikasi' fontIcon='fas fa-question-circle' />
    </>
  )
}
